import axios from "axios";

/**
 * Fetches the vehicle data
 * 
 * @param {String} vehicleIdentificationNumber The vehicle identification number
 * @param {String} bearer The bearer token
 * @returns The vehicle data
 */
export const fetchVehicle = async (vehicleIdentificationNumber, bearer) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_BASE_URL_REST_API_VEHICLE,
      {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
        params: {
          VIN: vehicleIdentificationNumber,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/**
 * Requests a remote action
 * 
 * @param {String} vehicleIdentificationNumber The vehicle identification number (VIN)
 * @param {Object} actions The remote actions to request
 * @param {String} bearer The bearer token
 * @returns The remote action response
 */
export const postRemoteAction = async (
  vehicleIdentificationNumber,
  actions,
  bearer,
) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL_REST_API_VEHICLE}/${vehicleIdentificationNumber}/remote-actions`,
      actions,
      {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/**
 * Fetches camera captures from the vehicle
 * @param {String} vehicleIdentificationNumber The vehicle identification number (VIN)
 * @param {String} row The row where the capture has been taken
 * @param {String} seat The seat where the capture has been taken
 * @param {String} bearer The bearer token
 * @returns The camera capture requested
 */
export const fetchCapture = async (vehicleIdentificationNumber, row, seat, bearer) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_BASE_URL_REST_API_VEHICLE + `/${vehicleIdentificationNumber}/images?row=${row}&seat=${seat}`,
      {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
};